
import { ISetTieuChuanSanPham } from "../../../model/respone/set-tieu-chuan/ISetTieuChuanSanPham"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eSetTieuChuanSanPhamActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ISetTieuChuanSanPham[],
    LOAD_ERROR: "",

    LOAD_DETAIL_START: 0,
    LOAD_DETAIL_SUCCESS: {} as ISetTieuChuanSanPham[],
    LOAD_DETAIL_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ISetTieuChuanSanPham,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as ISetTieuChuanSanPham,
    SAVE_SUCCESS: {} as ISetTieuChuanSanPham,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eSetTieuChuanSanPhamActionTypeIds = generateActionTypeIds(eSetTieuChuanSanPhamActionTypeDefine, "SET_TIEU_CHUAN_SAN_PHAM")

export type ISetTieuChuanSanPhamActions = IGenericActionType<typeof eSetTieuChuanSanPhamActionTypeDefine, "SET_TIEU_CHUAN_SAN_PHAM">